import { IDVGItemDTO, IGenericDTO } from "coreframetypings/dto";
import { IReadOnlyPrinterStatic } from '#/DefaultViewExtensionInterfaces';
import { staticImplements } from '@/Components/@Decorator/StaticImplementsDecorator';
import TypeConverter from '@/Utility/TypeConverter';
import SimpleCheckboxBuilder from '@/Builder/SimpleCheckboxBuilder';

@staticImplements<IReadOnlyPrinterStatic>()
export default class BoolPrinter {

    public static print(item: IDVGItemDTO, value: string, row: IGenericDTO): HTMLElement {
        const isChecked = value && value.toLowerCase() === 'true';
        return new SimpleCheckboxBuilder()
            .withIsReadonly(true)
            .withIsChecked(isChecked)
            .buildAndGetElement();
    }

    public static isRelevant(item: IDVGItemDTO, value: string, row: IGenericDTO): boolean {
        return TypeConverter.typeIsBool(item.dotNetTypeName);
    }

    public static createToolTip(item: IDVGItemDTO, value: string, row: IGenericDTO): string {
        return null;
    }
}